import { useQuery } from 'react-query';
import type { QueryOptions } from 'react-query';
import AffordableService from '../../services/affordableService';
import useAbortController from '../../hooks/useAbortController';

const placeholderData = [];

// The four codes MAT10 transmits, held in AffordableDisplacementStatusCode. Shared by every
// screen that asks why a household was displaced, so the vocabulary has one home.
const useAffordableDisplacementStatusCodesQuery = ({
  organizationId,
  options = {},
}: {
  organizationId: ?string,
  options?: QueryOptions,
} = {}) => {
  const abortControllerOptions = useAbortController();

  return useQuery(
    ['affordableDisplacementStatusCodes', organizationId],
    () => {
      const affordableService = new AffordableService();
      return affordableService.getAffordableDisplacementStatusCodes(
        organizationId ?? '',
        abortControllerOptions,
      );
    },
    { ...options, enabled: Boolean(organizationId), placeholderData },
  );
};

export default useAffordableDisplacementStatusCodesQuery;
